import React from "react"
import {graphql, Link, useStaticQuery} from "gatsby";
import {GatsbyImage, getImage} from "gatsby-plugin-image";
import Certifications from "./Certifications";

export default function Footer() {

    const data = useStaticQuery(graphql`
        query {
            allFile(
                filter: {
                    relativeDirectory: { eq: "logo" }, 
                    extension: {regex: "/(jpg|jpeg|png)/"}
                }
            ) {
                edges {
                    node {
                        name
                        childImageSharp {
                            gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED)
                        }   
                    }
                }
            }
        }   
  `);

    let images = {};
    data.allFile.edges.forEach(edge => {
        images[edge.node.name] = getImage(edge.node.childImageSharp);
    });

    return (
        <footer className="p-0">
            <Certifications />
            <div className="container">
                <div className="row align-items-center mb-4 sm-mb-6">
                    <div className="col-md-10 col-sm-8 text-center text-sm-start xs-mb-25px">
                        <h5 className="mb-0 text-dark-gray fw-400 ls-minus-1px">Let's make something great <Link to="/contact" className="text-decoration-line-bottom-medium fw-600 text-dark-gray text-dark-gray-hover">work together?</Link></h5>
                    </div>
                    <div className="col-md-2 col-sm-4 text-center text-sm-end">
                        <Link to="/" className="footer-logo d-inline-block">
                            {images['logo_full'] && (
                                <GatsbyImage
                                    image={images['logo_full']}
                                    data-at2x="images/demo-web-agency-logo-black@2x.png"
                                    alt="Matrixbrains pvt ltd company logo"
                                    loading="lazy"
                                />
                            )}
                        </Link>
                    </div>
                </div>
                <div className="row align-items-start mb-6 sm-mb-40px" style={{rowGap: "12px"}}>
                    <div className="col-lg-3 col-sm-6 text-center text-sm-start xs-mb-25px last-paragraph-no-margin">
                        <span className="d-block text-dark-gray ls-minus-05px mb-5px fw-600">Canada</span>
                        <p className="w-80 lg-w-100 text-medium-gray fs-15 lh-28">88, Corporate Drive Scarborough ON, Canada, M1H3G6</p>
                    </div>

                    <div className="col-lg-3 col-sm-6 text-center text-sm-start xs-mb-25px last-paragraph-no-margin">
                        <span className="d-block text-dark-gray ls-minus-05px mb-5px fw-600">Gujarat</span>
                        <p className="w-80 lg-w-100 text-medium-gray fs-15 lh-28">A-202, Titanium Heights, Corporate Rd,
                            Prahlad Nagar, Ahmedabad</p>
                    </div>
                    <div className="col-lg-3 col-sm-6 text-center text-sm-start xs-mb-25px last-paragraph-no-margin">
                        <span className="d-block text-dark-gray ls-minus-05px mb-5px fw-600">Rajasthan</span>
                        <p className="w-80 lg-w-100 text-medium-gray fs-15 lh-28">27, Krishna Nagar, Peacock Hills,
                            Titardi, Udaipur</p>
                    </div>
                    <div className="col-lg-3 col-sm-6 last-paragraph-no-margin ms-auto text-center text-sm-end">
                        <a href="tel:+916352371990" className="text-dark-gray d-block lh-18 text-dark-gray-hover">+91 635 237 1990</a>
                        <a href="mailto:business@matrixbrains.com" className="text-dark-gray text-dark-gray-hover fw-600 text-decoration-line-bottom">
                            <span className="__cf_email__" data-cfemail="761f1810193612191b171f185815191b">business@matrixbrains.com</span>
                        </a>
                    </div>
                </div>
            </div>
            <div className="footer-bottom pt-25px pb-25px border-top border-color-charcoal-grey">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-7 text-center text-lg-start md-mb-10px">
                            <ul className="footer-navbar fw-600 fs-16">
                                <li className="nav-item active">
                                    <Link to="/" className="nav-link">Home</Link>
                                </li>
                                <li className="nav-item">
                                    <Link to="/cloud-support" className="nav-link">Cloud Support</Link>
                                </li>
                                <li className="nav-item">
                                    <Link to="/agency-about" className="nav-link">Agency</Link>
                                </li>
                                <li className="nav-item">
                                    <Link to="/expertise" className="nav-link">Expertise</Link>
                                </li>
                                <li className="nav-item">
                                    <Link to="/portfolio" className="nav-link">Portfolio</Link>
                                </li>
                                <li className="nav-item">
                                    <Link to="/people" className="nav-link">People</Link>
                                </li>
                                <li className="nav-item">
                                    <Link to="/blog" className="nav-link">Blog</Link>
                                </li>
                                <li className="nav-item">
                                    <Link to="/contact" className="nav-link">Contact</Link>
                                </li>
                            </ul>
                        </div>
                        <div className="col-lg-5 text-center text-lg-end">
                            <span className="fs-15">© 2024 Proudly Powered by <Link to="/" className="text-decoration-line-bottom text-dark-gray text-dark-gray-hover fw-500" target="_blank" rel="noreferrer">Matrixbrains</Link></span>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}
